import { toastError, toastSuccess } from "../../config/ToastModal";
import isEmpty from "../../lib/isEmpty";
import { changePassword } from "../../services/auth";
import { changePasswords } from "../../validation/login";
import { useEffect, useState } from "react";
import eyeOn from "../../assests/images/view.png";
import eyeOff from "../../assests/images/hide.png";
import { removeAuthToken } from "../../lib/localStorage";
import { useNavigate } from "react-router-dom";

const initialFormValue = {
  oldPassword: "",
  newPassword: "",
  confirmPassword: "",
};

const Form = () => {
  const router = useNavigate();
  const [touched, setTouched] = useState({});
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState(initialFormValue);

  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [isConPasswordVisible, setIsConPasswordVisible] = useState(false);
  const [isConPasswordVisible1, setIsConPasswordVisible1] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleBlur = ({ target: { name } }) => {
    setTouched((prevTouched) => ({ ...prevTouched, [name]: true }));
  };

  const togglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };
  const toggleConPasswordVisibility = () => {
    setIsConPasswordVisible(!isConPasswordVisible);
  };

  const toggleConPasswordVisibility1 = () => {
    setIsConPasswordVisible1(!isConPasswordVisible1);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const { oldPassword, newPassword, confirmPassword } = formData;

      if (!oldPassword || !newPassword || !confirmPassword) {
        toastError("Please Enter All Field..!");
      }

      if (oldPassword && newPassword && confirmPassword) {
        if (newPassword == confirmPassword) {
          const { status, message, errors } = await changePassword({
            oldPassword,
            newPassword,
            confirmPassword,
          });
          if (!status) {
            setErrors(errors);
            toastError(errors.password);
          } else {
            toastSuccess(message);
            setFormData(initialFormValue);
            setTouched({});
            removeAuthToken();
            router("/");
          }
        } else {
          toastError("Confirm password does not match new password");
        }
      }
    } catch (err) {
    }
  };

  useEffect(() => {
    const checkValidation = changePasswords(formData);
    if (!checkValidation.status) {
      setErrors(checkValidation.errors);
    } else {
      setErrors({});
    }
  }, [formData]);

  return (
    <form className="default-form">
      <div className="row">
        <div className="form-group col-lg-7 col-md-12">
          <label>
            Old Password <span className="text-danger">*</span>
          </label>
          {/* <input
            type="password"
            name="oldPassword"
            value={formData.oldPassword}
            onChange={handleInputChange}
            onBlur={handleBlur}
            placeholder="Please Enter Old Password"
          />
          {touched.oldPassword && errors.oldPassword && (
            <span className="text-danger">{errors.oldPassword}</span>
          )} */}

          <div className="password-section">
            <input
              type={isConPasswordVisible1 ? "text" : "password"}
              name="oldPassword"
              value={formData.oldPassword}
              onChange={handleInputChange}
              onBlur={handleBlur}
              placeholder="Please Enter Old Password"
            />
            <img
              src={isConPasswordVisible1 ? eyeOn : eyeOff}
              className="password-icon"
              alt="toggle password"
              onClick={toggleConPasswordVisibility1}
              style={{ cursor: "pointer" }}
            />
            {touched.oldPassword && errors.oldPassword && (
              <span className="text-danger">{errors.oldPassword}</span>
            )}
          </div>
        </div>

        <div className="form-group col-lg-7 col-md-12">
          <label>
            New Password <span className="text-danger">*</span>
          </label>
          {/* <input
            type="password"
            name="newPassword"
            value={formData.newPassword}
            onChange={handleInputChange}
            onBlur={handleBlur}
            placeholder="Please Enter New Password"
          />
          {touched.newPassword && errors.newPassword && (
            <span className="text-danger">{errors.newPassword}</span>
          )} */}

          <div className="password-section">
            <input
              type={isPasswordVisible ? "text" : "password"}
              name="newPassword"
              value={formData.newPassword}
              onChange={handleInputChange}
              onBlur={handleBlur}
              placeholder="Please Enter New Password"
            />
            <img
              src={isPasswordVisible ? eyeOn : eyeOff}
              className="password-icon"
              alt="toggle password"
              onClick={togglePasswordVisibility}
              style={{ cursor: "pointer" }}
            />
          </div>
        </div>

        <div className="form-group col-lg-7 col-md-12">
          <label>
            Confirm Password <span className="text-danger">*</span>
          </label>
          {/* <input
            type="password"
            name="confirmPassword"
            value={formData.confirmPassword}
            onChange={handleInputChange}
            onBlur={handleBlur}
            placeholder="Please Enter Confirm Password"
          />
          {touched.confirmPassword && errors.confirmPassword && (
            <span className="text-danger">{errors.confirmPassword}</span>
          )} */}

          <div className="password-section">
            <input
              type={isConPasswordVisible ? "text" : "password"}
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleInputChange}
              onBlur={handleBlur}
              placeholder="Please Enter Confirm Password"
            />
            <img
              src={isConPasswordVisible ? eyeOn : eyeOff}
              className="password-icon"
              alt="toggle password"
              onClick={toggleConPasswordVisibility}
              style={{ cursor: "pointer" }}
            />
          </div>
        </div>

        <div className="form-group col-lg-6 col-md-12">
          <button
            type="submit"
            className="theme-btn btn-style-one"
            // style={!isEmpty(errors) ? { cursor: "not-allowed" } : {}}
            // disabled={!isEmpty(errors)}

            onClick={handleSubmit}
          >
            Update Password
          </button>
        </div>
      </div>
    </form>
  );
};

export default Form;
